module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("POOKIEST")]), _vm._v(" S"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("TORIES")]), _vm._v(" E"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("VER")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/logo.png"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EASONS OF")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENTUCKY")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOSTS")]), _c('br'), _c('br')]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OBERTA")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IMPSON")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROWN")]), _c('br'), _vm._v("AND L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONNIE")]), _vm._v(" E. B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROWN")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OREWORD BY")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LIZABETH")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UCKER")]), _c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/logo3.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-760f8085","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780813173894_epub_tp_r1.vue
// module id = 60
// module chunks = 0